module.exports = __webpack_public_path__ + "img/10.86726ae1.png";